(function () {
  var WOMEN_IMG = 'https://cdn.shopify.com/s/files/1/0976/7541/1781/files/IJTkBSPSxhGEloIA9l-xbwGOaPLr1hHf.jpg';
  var MEN_IMG   = 'https://cdn.shopify.com/s/files/1/0976/7541/1781/files/TWC5ww0hLaaOaSmRZyX8UHF1n9wCHBBP.jpg';
  var BUNDLES_IMG = 'https://cdn.shopify.com/s/files/1/0976/7541/1781/files/4uD1rIrGxXPDBs0sUqm5705Lb40GqoTr.jpg?v=1786843274';
  var CONFIGS = [
    { id: '#HeaderMenu-MenuList-2', heading: "Women's Collection", imgSrc: WOMEN_IMG, imgLabel: 'Exosome & Niacinamide Serum' },
    { id: '#HeaderMenu-MenuList-3', heading: "Men's Collection", imgSrc: MEN_IMG, imgLabel: 'Softening Beard Oil' },
    { id: '#HeaderMenu-MenuList-4', heading: 'Ritual Bundles', imgSrc: BUNDLES_IMG, imgLabel: 'The Couples Glow Serum Ritual' }
  ];
  function buildMega(menu, heading, imgSrc, imgLabel) {
    if (menu.dataset.sdcMega) return;
    menu.dataset.sdcMega = '1';
    var items = Array.prototype.slice.call(menu.querySelectorAll('li'));
    var linksHtml = items.map(function (li) {
      var a = li.querySelector('a');
      if (!a) return '';
      return '<a class="sdc-mega-link" href="' + a.getAttribute('href') + '">' + a.textContent.trim() + '</a>';
    }).join('');
    menu.innerHTML = '<div class="sdc-mega-inner"><div class="sdc-mega-links"><div class="sdc-mega-heading">' + heading + '</div>' + linksHtml + '</div><div class="sdc-mega-divider"></div><div class="sdc-mega-image"><img src="' + imgSrc + '" alt="' + imgLabel + '" loading="eager"><div class="sdc-mega-image-label">' + imgLabel + '</div></div></div>';
  }
  function updateMegaTop() {
    var header = document.querySelector('header.header') || document.querySelector('header');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--sdc-mega-top', bottom + 'px');
  }
  function fixSkincareLayout() {
    if (window.location.pathname !== '/collections/skincare') return;
    var sections = Array.prototype.slice.call(document.querySelectorAll('[id^="shopify-section-template"]'));
    if (sections.length < 2) return;
    var descSection = null;
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].id.indexOf('collection_banner_table') !== -1) { descSection = sections[i]; break; }
    }
    if (!descSection) return;
    var firstSection = sections[0];
    if (firstSection !== descSection) {
      firstSection.parentNode.insertBefore(descSection, firstSection);
    }
    // Override the display:none !important set by womens_banner_custom_liquid
    descSection.style.setProperty('display', 'block', 'important');
    // Hide the empty hero image wrapper (550px blank space)
    var bannerWrapper = descSection.querySelector('.collection-banner-wrapper');
    if (bannerWrapper) bannerWrapper.style.setProperty('display', 'none', 'important');
    // Hide the lifestyle banner section (womens_banner_custom_liquid)
    for (var j = 0; j < sections.length; j++) {
      if (sections[j].id.indexOf('womens_banner_custom_liquid') !== -1) {
        sections[j].style.setProperty('display', 'none', 'important');
        break;
      }
    }
  }
  function init() {
    CONFIGS.forEach(function (cfg) {
      var menu = document.querySelector(cfg.id);
      if (menu) buildMega(menu, cfg.heading, cfg.imgSrc, cfg.imgLabel);
    });
    updateMegaTop();
    fixSkincareLayout();
    window.addEventListener('scroll', updateMegaTop, { passive: true });
    window.addEventListener('resize', updateMegaTop, { passive: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();